import { render, staticRenderFns } from "./BirthdayDetails.vue?vue&type=template&id=2fc4e5a4&scoped=true&"
import script from "./BirthdayDetails.vue?vue&type=script&lang=js&"
export * from "./BirthdayDetails.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayDetails.vue?vue&type=style&index=0&id=2fc4e5a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc4e5a4",
  null
  
)

export default component.exports